import { getCore } from "../../utils/httpInterceptor";

class axBaseEnumsMetaService {
  static async getOptions(enumName, lang) {
    if (!enumName) {
      return [];
    }

    const query = new URLSearchParams();
    if (lang) {
      query.append("lang", lang);
    }

    const qs = query.toString();
    const path = `/api/meta/ax-base-enums/${encodeURIComponent(enumName)}/options${qs ? `?${qs}` : ""}`;

    try {
      const data = await getCore(path);
      return Array.isArray(data) ? data : [];
    } catch (error) {
      return [];
    }
  }
}

export default axBaseEnumsMetaService;
